var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgChatTeardropText(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3125 16.8744H3.72396C3.56511 16.8744 3.41276 16.8113 3.30043 16.699C3.1881 16.5866 3.125 16.4343 3.125 16.2754V9.68687C3.125 8.743 3.31091 7.80837 3.67211 6.93634C4.03332 6.06432 4.56275 5.27197 5.23017 4.60456C5.89759 3.93714 6.68993 3.40771 7.56195 3.0465C8.43398 2.6853 9.36861 2.49939 10.3125 2.49939H10.3125C11.2564 2.49939 12.191 2.6853 13.063 3.04651C13.9351 3.40771 14.7274 3.93714 15.3948 4.60456C16.0623 5.27198 16.5917 6.06433 16.9529 6.93635C17.3141 7.80838 17.5 8.74301 17.5 9.68689V9.6869C17.5 11.5931 16.7427 13.4213 15.3948 14.7692C14.0469 16.1171 12.2188 16.8744 10.3125 16.8744Z",
    stroke: "#0079C0",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.8125 8.74939H12.5",
    stroke: "#0079C0",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.8125 11.2494H12.5",
    stroke: "#0079C0",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatTeardropText);
export default __webpack_public_path__ + "static/media/ChatTeardropText.fe63514e7352753d0ce589697849d6ee.svg";
export { ForwardRef as ReactComponent };